import { Stack, Typography } from "@mui/material";

interface OrderDetailsRowProps {
  label: string;
  value: string;
}

interface Option {
  id: string;
  label: string;
}

export const getDisplayOption = (value: string, options: Option[]): string => {
  const mappedValue = options.find(
    (option: Option) => option?.id === value,
  )?.label;
  return mappedValue || value;
};

const OrderDetailsRow = ({ label, value }: OrderDetailsRowProps) => (
  <Stack
    direction="row"
    sx={{
      gap: 1,
      alignItems: "center",
    }}
  >
    <Typography variant="subtitle2" data-testid={`${label}-label`}>
      {label}
    </Typography>
    <Typography variant="body2" data-testid={`${label}-value`}>
      {value}
    </Typography>
  </Stack>
);

export default OrderDetailsRow;
